import Navbar from './components/Navbar';
import Hero from './components/Hero';
import WhatIsSection from './components/WhatIsSection';
import ComparisonSection from './components/ComparisonSection';
import CategoryGrid from './components/CategoryGrid';
import FeaturedCategories from './components/FeaturedCategories';
import GuidesSection from './components/GuidesSection';
import FAQSection from './components/FAQSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <main className="min-h-screen">
      <Navbar />
      <Hero />
      <WhatIsSection />
      <ComparisonSection />
      <CategoryGrid />
      <FeaturedCategories />
      <GuidesSection />
      <FAQSection />
      <Footer />
    </main>
  );
}